module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"dialogTitle":"Помощь в настройке оборудования","subjectTitle":"Тема обращения","subjectInputLabel":"Тема обращения","commentTitle":"Опишите проблему","commentInputLabel":"Опишите, как возникла проблема","contactsTitle":"Как с вами связаться","contactsNameLabel":"Имя","contactsEmailLabel":"Email","contactsPhoneLabel":"Телефон","send":"Отправить"}}')
  delete Component.options._Ctor
}
